import { getRemoteAppConfig } from '..';
import { remoteStore } from './registerStore';
class EnvConfig {
    remoteName;
    configPath;
    static instances = new Map();
    configPromise;
    constructor(remoteName, configPath) {
        this.remoteName = remoteName;
        this.configPath = configPath;
        if (EnvConfig.instances.has(remoteName)) {
            throw new Error(`EnvConfig instance for ${remoteName} already exists!`);
        }
        this.configPromise = this.loadConfig();
        EnvConfig.instances.set(remoteName, this);
    }
    static getInstance(remoteName, configPath) {
        if (!this.instances.has(remoteName)) {
            new EnvConfig(remoteName, configPath);
        }
        return this.instances.get(remoteName);
    }
    get() {
        if (!this.configPromise) {
            this.configPromise = this.loadConfig();
        }
        return this.configPromise;
    }
    async loadConfig() {
        return getRemoteAppConfig(this.configPath).then(config => {
            remoteStore.setConfig(this.remoteName, config);
            return config;
        });
    }
}
export { EnvConfig };
